import { Component } from '@angular/core';

import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ConfirmationConfig, ConfirmService } from '../../../Utils/_services/confirmation-dialog.service';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [DialogModule, ButtonModule],
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css']
})
export class ConfirmationModalComponent {
  visible = false;
  config: ConfirmationConfig = {
    header: 'Confirmation',
    bodyHeader: 'Are you sure?',
    
    yesButtonText: 'Yes',
    noButtonText: 'No',
   
    width: '450px'
  };

  private resolveCallback?: (result: boolean) => void;

  constructor(private confirmationService: ConfirmService) {
    this.confirmationService.confirmationRequest$.subscribe(
      ({ config, resolve }) => {
        this.config = { ...this.config, ...config };
        this.visible = true;
        this.resolveCallback = resolve;
      }
    );
  }

  handleConfirm() {
    if (this.resolveCallback) {
      this.resolveCallback(true);
    }
    this.closeDialog();
  }

  handleCancel() {
    if (this.resolveCallback) {
      this.resolveCallback(false);
    }
    this.closeDialog();
  }

  closeDialog() {
    this.visible = false;
    this.resolveCallback = undefined;
  }
}